import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide05Benefits({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-103">
      <SlideHeader eyebrow="Proposed Campaign Model" data-id="element-104">
        Each campaign becomes a short interactive journey
      </SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-6xl mx-auto w-full" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="w-full flex justify-center items-center" data-id="element-106">
          <img src="https://cdn.magicpatterns.com/uploads/8pJ9cD3w7mzFvc5zaeqAe3/Screenshot_2026-06-29_at_12.53.19.png" alt="GSK Amoxil Example Campaign Flow" className="w-full max-w-5xl h-auto object-contain rounded-2xl shadow-sm border border-black/5" data-id="element-107" />
        </motion.div>
      </div>
    </InteriorSlide>;
}